import React, {useState} from 'react';
import {Col, Row, Typography} from 'antd';
import ReportDateRangeFilter from '../../components/admin/reports/ReportDateRangeFilter';
import ProductsChart from './reports/ecommerce/ProductsChart';
import DestinationsChart from './reports/ecommerce/DestinationsChart';
import RevenueChart from './reports/ecommerce/RevenueChart';
import DiscountsSection from './reports/ecommerce/DiscountsSection';
import GrowthChart from './reports/ecommerce/GrowthChart';
import FrequencySummaryTiles from './reports/ecommerce/FrequencySummaryTiles';
import FrequencyDetailTable from './reports/ecommerce/FrequencyDetailTable';
import {getStartMonth, getEndMonth} from '../../utils/utils';

export default function AdminReportsEcommerce() {
    const [dateRange, setDateRange] = useState([getStartMonth(), getEndMonth()]);
    const [appliedRange, setAppliedRange] = useState(dateRange);

    const dateFrom = appliedRange[0].format('YYYY-MM-DD');
    const dateTo = appliedRange[1].format('YYYY-MM-DD');

    return (
        <div>
            <Row justify="space-between" align="middle" style={{marginBottom: 24}} wrap>
                <Col>
                    <Typography.Title level={4} style={{margin: 0}}>Relatórios - Ecommerce</Typography.Title>
                </Col>
                <Col>
                    <ReportDateRangeFilter
                        value={dateRange}
                        onChange={setDateRange}
                        onApply={() => setAppliedRange(dateRange)}
                    />
                </Col>
            </Row>

            <div style={{marginBottom: 16}}>
                <FrequencySummaryTiles dateFrom={dateFrom} dateTo={dateTo}/>
            </div>

            <div style={{marginBottom: 16}}>
                <RevenueChart dateFrom={dateFrom} dateTo={dateTo}/>
            </div>

            <div style={{marginBottom: 16}}>
                <GrowthChart dateFrom={dateFrom} dateTo={dateTo}/>
            </div>

            <Row gutter={[16, 0]}>
                <Col xs={24} lg={12}>
                    <ProductsChart dateFrom={dateFrom} dateTo={dateTo}/>
                </Col>
                <Col xs={24} lg={12}>
                    <DestinationsChart dateFrom={dateFrom} dateTo={dateTo}/>
                </Col>
            </Row>

            <div style={{marginBottom: 16}}>
                <DiscountsSection dateFrom={dateFrom} dateTo={dateTo}/>
            </div>

            <div style={{marginBottom: 16}}>
                <FrequencyDetailTable dateFrom={dateFrom} dateTo={dateTo}/>
            </div>
        </div>
    );
}
